<template>
    <div class="element ReferralField" :data-required="this.required" :class="error.error ? 'error' : ''">
        <div class="row" v-if="this.preview">
            <div class="col-sm-6 leftcolumn">
                <div class="h4">{{ trans("QR-code") }}</div>
                <qr :url="url" />
            </div>
            <div class="col-sm-6 rightcolumn">
                <div class="h4">{{ trans("Referral link") }}</div>
                 <div class="input-group">
                     <input type="text" class="input form-control" @click.prevent="handleSelect" @keydown="handleKeydown" :value="url">
                     <div class="input-group-btn">
                         <button class="btn" type="button" @click.prevent="handleCopy">
                             <Icon name="copy" />
                         </button>
                     </div>
                 </div>

                <div class="aside">

                    <div class="h3">{{ trans("Direct een aanvraag indienen?")}}</div>
                    <div class="Text">
                        <p v-html='trans("Ben je ambassadeur en wil je een directe aanvraag doen? Gebruik dan onderstaande knop om het proces te starten.")'></p>
                    </div>

                    <nav>
                        <a :href="ambassador_url" target="_blank" class="more bg3">
                            <span class="title">{{ trans("Ambassadeursaanvraag starten") }}</span>
                        </a>
                    </nav>
                </div>
            </div>
        </div>
        <input
            v-else
            class="input"
            type="text"
            :id="`field_${this.id}`"
            :name="this.name"
            :readonly="!this.editing || this.readonly"
            :placeholder="this.placeholder"
            :autocomplete="this.autocomplete"
            :maxlength="this.maxlength"
            v-model="input"
            @keyup="validateInput"
            @blur="validateInput"
        />
        <div v-if="error.error" class="error">{{ trans(error.message) }}</div>
    </div>
</template>

<script>
import {ref, watch, computed} from "vue";

// Our form helpers
import useFormValidation from "./_validation";
import { propDefaults } from "./_props";

import { addNotification } from "store/notifications";

// Our helpers
import { getUrlWithQueryItemReplaced } from "helpers/_structure";
import { mergeDeep } from "helpers/_objects";
import trans from "helpers/_translation";

import Icon from "components/icon";

import qr from "components/qr";

import { resolveProps } from "formbuilder/fields/_props";
import labelElement from "formbuilder/elements/LabelElement.vue";

export default {
    props: mergeDeep(
        propDefaults,
        {

        }
    ),
    components: {
        Icon,
        qr,
        labelElement
    },
    setup(props) {

        let input = ref("");
        const {validateTextField, error} = useFormValidation();
        const validateInput = () => {
            if (props.required) {
                validateTextField(props.label, input.value);
            }
        };

        watch(
            () => props.value,
            () => {
                input.value = props.value;
                if (!props.editing && !props.value) {
                    input.value = "-";
                }
            },
            {
                immediate: true
            }
        );

        const url = computed(() => {
            return trans(`${props.extra.url}`, input.value);
        });
        const ambassador_url = computed(() => {
            return `${url.value}&ambassadeur`;
        });

        const handleSelect = (e) => {
            const target = e.currentTarget || e.target;
            target.select();
        };
        const handleKeydown = (e) => {
            // Allow Ctrl+C for copy operation
            if (e.ctrlKey && e.key === 'c') {
                return; // Do not prevent default
            }
            // Prevent other key actions
            e.preventDefault();
        };

        const handleCopy = () => {

            navigator.clipboard.writeText(url.value)
                .then(() => {
                    addNotification(trans("Referral link is gekopieërd."), 3500);
                })
                .catch(err => {
                    addNotification(trans("Er ging iets fout met kopiëren."), 3500);
                });
        };

        return {
            resolveProps,
            input,

            error,
            validateInput,
            trans,

            url,
            ambassador_url,

            handleSelect,
            handleKeydown,
            handleCopy
        };
    },
}
</script>